import isFlagOn from '~/composables/feature-flag'
import { FEATURE_FLAG } from '~/constants/feature-flags.constants'

/*
 * Single source of truth for whether the descopMFA journey (login OTP challenge,
 * post-registration enrollment, account-settings two-step section) should show.
 *
 * Fails closed: a missing/errored/undefined Split.io treatment resolves to
 * false (same contract as isFlagOn) — a misconfigured or absent flag must
 * never turn MFA on for a real user.
 */
export default function isDescopeMfaEnabled () {
  return isFlagOn(FEATURE_FLAG.descopMFA).catch(() => false)
}
